// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"JF-z"};